import React, { Component } from 'react';
import NotesElement from '../../components/notes/NotesElement';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';

/**
 * Renders NotesElement and allows editing and saving of notes
 * @props {Array} notes - redux -> state.notes
 * @props {function} removeNoteStateOnly - redux -> notes.removeNoteStateOnly()
 * @props {function} saveNote - redux -> notes.saveNote()
 * @props {function} removeNote - redux -> notes.removeNote()
 * @returns NotesElement
 */
class NotesElementContainer extends Component {
	state = {
		'isEditing' : false,
		'currentText': '',
		'currentNoteType': 'issue'
	}
	
	componentDidMount() {
		const { key } = this.getCurrentNote();
		if(key === null) {
			this.editOn();
		}
	}
	
	render() { 
		const { editOn, editOff, noteTextChange, noteTypeChange, saveNote, removeNote } = this;
		const actions = {
			editOn,
			editOff,
			noteTextChange,
			noteTypeChange,
			saveNote,
			removeNote
		};
		const note = this.getCurrentNote();
		const props = {...this.state, ...note, ...actions};
		return <NotesElement 
			{...props}
		/>
	}
	
	noteTextChange = (e) => {
		const value = e.target.value;
		this.setState({'currentText': value})
	}
	
	noteTypeChange = (value) => {
		this.setState({'currentNoteType': value})
	} 
	
	editOn = () => {
		const { note } = this.getCurrentNote();
		this.setState({
			'isEditing': true,
			'currentText': note
		})
	}
	
	editOff = () => {
		const { removeNoteStateOnly, noteIndex } = this.props;
		const { key } = this.getCurrentNote();
		if(key === null) {
			removeNoteStateOnly(noteIndex)
		}
		this.setState({
			'isEditing': false
		})
	}
	
	saveNote = () => {
		const { saveNote, noteIndex } = this.props;
		const { currentText, currentNoteType } = this.state;
		const noteObj = {
			currentText,
			currentNoteType,
			noteIndex
		}
		saveNote(noteObj);
		this.setState({'isEditing': false})
	}
	
	removeNote = () => {
		const { noteIndex, removeNote, key } = this.props;
		const noteObj = {
			active: 'N',
			noteIndex, 
			key
		}
		removeNote(noteObj);
	}
		
	getCurrentNote = () => {
		const { noteIndex, notes } = this.props;
		return notes.notesList[noteIndex];
	}
}

function mapStateToProps(state) {
	return {
		notes: state.notes
	}
}

const mapDispatchToProps = dispatch => {
	return {
		removeNoteStateOnly: (index) => {
			dispatch(actions.notes.removeNoteStateOnly(index));
		},
		saveNote: (noteObj) => {
			dispatch(actions.notes.saveNote(noteObj));
		},
		removeNote: (noteObj) => {
			dispatch(actions.notes.removeNote(noteObj));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotesElementContainer);



// WEBPACK FOOTER //
// ./src/containers/notes/NotesElementContainer.jsx